class StringUtilities {
  public static startsWithAny: (str: string, prefixes: string[]) => boolean = (str, prefixes) => {
    return prefixes.some((prefix) => str.startsWith(prefix))
  }
}

export default StringUtilities
